import { useCallback } from 'react';
import { initReactI18next, useTranslation } from 'react-i18next';
import i18n, { TOptions } from 'i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en'],
    interpolation: { escapeValue: false },
    backend: { loadPath: '/lang/{{lng}}/{{ns}}.json' },
  });

export default i18n;

export { useTranslation } from 'react-i18next';

export const useTranslationX = (baseKey: string, namespace?: string | string[]) => {
  const props = useTranslation(namespace);
  const t = props.t;

  const tx = useCallback(
    (key: string, options?: TOptions | string) => t(`${baseKey}.${key}`, options),
    [baseKey, t]
  );

  return { ...props, tx };
};
